import React from 'react';
import PropTypes from 'prop-types';

const propTypes = {
  color: PropTypes.string,
  size: PropTypes.number,
};

const MapMarkerIcon = ({ color = '#000', size = 8, ...props }) => (
  <svg
    viewBox="0 0 8 12"
    xmlns="http://www.w3.org/2000/svg"
    width={size}
    {...props}
  >
    <path
      d="M4 0C1.782 0 0 1.837 0 4.125 0 6.412 4 12 4 12s4-5.588 4-7.875C8 1.837 6.218 0 4 0zm0 6c-1.018 0-1.818-.825-1.818-1.876 0-1.05.8-1.875 1.818-1.875s1.818.825 1.818 1.875S5.018 6 4 6z"
      fill={color}
      fillRule="evenodd"
    />
  </svg>
);

MapMarkerIcon.propTypes = propTypes;

export default MapMarkerIcon;
